<template>
  <div class="home_category" v-if="productList && productList.length > 0 ">
    <div class="sub_heading flx">
      <h4>{{title}}</h4>
      <span class="see_all" @click="getMerchandiseProducts()" v-if="$route.name != 'ProductDetail'">{{$t('seeAll')}}</span>
    </div>
    <ul class="wrap_listing flx" :style="[$route.name == 'ProductDetail'  ? { 'paddingBottom' : '50px'} : {'paddingBottom' : '0px'} ]">
      <li
        class="filter_card"
        v-for="(product,index) in productList"
        :key="index"        
      >
       <div
          class="img_wrapper spinner_wrapper"
          @click="goToProductDetail(product.saleReferenceID)"
          v-lazyload
          v-if="product.displayImage"
        >
          <ImageSpinner class="image_spinner" />
          <img :data-url="product.displayImage" alt="product" />
        </div>

        <div class="product_detail">
          <div class="my_price_section">
            <span class="my_price">₹​ {{product.groupPrice}}</span>
            <span class="selling_price">₹​ {{product.markedPrice}}</span>
          </div>
          <p class="bought">
            {{product.peopleBought}}
            {{$t('peopleHaveBrought')}}
          </p>
        </div>
      </li>
       <span class="view_all_list" v-if="dataValue.length > 9 && $route.name == 'ProductDetail'" @click="getMerchandiseProducts()" >{{$t('viewAllProducts')}} </span>
    </ul>      
  </div>
</template>

<script>
import { mapState } from "vuex";
import ImageSpinner from "../Common/ImageSpinner";
import constant from "../../utils/constant";
import { bus } from "../../main";

export default {
  name: "ProductCard",
  components: {
    ImageSpinner
  },
  props: {
    title: {
      required: true,
      type: String
    },
    dataValue: {
      required: true,
      type: Array
    },
    merchantId: {
      required: true
    },
    getMyPrice: {
      type: Boolean
    }
  },
  watch: {
    dataValue() {
      if (
        this.title == this.$t("trendingProd") ||
        this.title == this.$t("newCollection")
      ) {
        this.productList = this.dataValue.slice(0, 4);
      } else {
        this.productList = this.dataValue.slice(0, 6);
      }
    }
  },
  data() {
    return {
      productList: [],
      loading: false,
      cntntLoad: false
    };
  },
  methods: {
    getUserPrice(saleReferenceID, productDto) {
      this.cntntLoad = true;
      this.$store
        .dispatch({
          type: "getUserPriceProduct",
          payload: saleReferenceID
        })
        .then(data => {
          productDto.sellingPrice = data.data.totalPaidAmount;
          this.cntntLoad = false;
        })
        .catch(err => {
          this.cntntLoad = false;
          productDto.sellingPrice = productDto.groupPrice;
          console.log(err);
        });
    },
    getMerchandiseProducts() {
      if (this.$props.title == this.$t("trendingProd")) {
        clevertap.event.push("merchandising_banner_click", {
          merchandiseId: this.$props.merchantId
        });
        this.$router.onError(err => {
          if (/loading chunk \d* failed./i.test(err.message)) {
            window.location.reload();
          }
        });
        this.$router.push(
          "/merchandise-product-by-id/" + this.$props.merchantId
        );
      } else if (this.$props.title == this.$t("newCollection")) {
        this.$router.onError(err => {
          if (/loading chunk \d* failed./i.test(err.message)) {
            window.location.reload();
          }
        });
        this.$router.push("/product-by-category?type=NEW_COLLECTION");
      } else if (this.$props.title == this.$t("clearanceSale")) {
        this.$router.onError(err => {
          if (/loading chunk \d* failed./i.test(err.message)) {
            window.location.reload();
          }
        });
        this.$router.push("/product-by-category?type=CLEARANCE_SALE");
      } else if (this.$props.title == this.$t("relatedProduct")) {
        this.$router.onError(err => {
          if (/loading chunk \d* failed./i.test(err.message)) {
            window.location.reload();
          }
        });
        this.$router.push(
          `/product-by-category?type=NORMAL&categoryid=${this.$props.merchantId}`
        );
      }
    },
    goToProductDetail(productSrId) {
      this.$router.onError(err => {
        if (/loading chunk \d* failed./i.test(err.message)) {
           window.location.reload()
        }
      });
      this.$router.push({
        path: "/detail/" + productSrId
      });
      if (this.$props.title == this.$t("relatedProduct")) {
        this.$router.go({
          path: "/detail/" + productSrId
        });
      }
    }
  },
  mounted() {
    if (
      this.title == this.$t("trendingProd") ||
      this.title == this.$t("newCollection")
    ) {
      this.productList = this.dataValue.slice(0, 4);
    } else {
      this.productList = this.dataValue.slice(0, 6);
    }
  }
};
</script>
